"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.icons = exports.logos = exports.colours = exports.headBoxDesignSystemTheme = exports.antdTheme = void 0;

var colours = _interopRequireWildcard(require("./colours"));

exports.colours = colours;

var logos = _interopRequireWildcard(require("./logos"));

exports.logos = logos;

var icons = _interopRequireWildcard(require("./icons"));

exports.icons = icons;

var _typography = require("./typography");

var themes = _interopRequireWildcard(require("./themes"));

var white = colours.white,
    black = colours.black,
    primary = colours.primary;
var headBoxDesignSystemTheme = themes.headBoxDesignSystemTheme;
exports.headBoxDesignSystemTheme = headBoxDesignSystemTheme;
var antdTheme = {
  'font-family': _typography.montserrat,
  'font-size-base': _typography.baseSize,
  white: white,
  black: black,
  'primary-color': primary,
  'layout-body-background': white,
  'layout-header-background': white
};
exports.antdTheme = antdTheme;